import { adapter, initialState, State } from './state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  AddVendorComplete,
  DeleteVendorComplete,
  DeleteVendorsComplete,
  GetVendorByIdComplete,
  LoadVendersComplete,
  UpdateVendorComplete,
  UpdateVendorsComplete,
} from './actions'

export const reducer = createReducer(
  initialState,
  on(LoadVendersComplete, (state, { items }) => adapter.setAll(items, { ...state, isLoaded: true })),
  on(AddVendorComplete, UpdateVendorComplete, GetVendorByIdComplete, (state, { item }) => adapter.setOne(item, state)),
  on(UpdateVendorsComplete, (state, { updates }) => adapter.updateMany(updates, state)),
  on(DeleteVendorComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(DeleteVendorsComplete, (state, { ids }) => adapter.removeMany(ids, state))
)

export function vendorsReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
